import { jwtDecode } from "jwt-decode";
import { useAuth } from "react-oidc-context";

export function useAuthOverride() {
  const oidcAuth = useAuth();
  const overrideToken = import.meta.env.VITE_ACCESS_TOKEN_OVERRIDE;

  if (overrideToken) {
    let decoded: Record<string, any> = {};

    try {
      decoded = jwtDecode(overrideToken);
    } catch (e) {
      console.warn("Failed to decode override token", e);
    }

    return {
      ...oidcAuth,
      isAuthenticated: true,
      user: {
        profile: {
          idp: decoded.idp ?? decoded.iss ?? "",
          email: decoded.email ?? "",
          name: decoded.name ?? "",
        },
        access_token: overrideToken,
      } as unknown,
    } as unknown as typeof oidcAuth;
  }

  return oidcAuth;
}
